import React, { useState, useEffect } from 'react';
import jwtDecode from 'jwt-decode';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { WaveLoading } from 'react-loadingg';

import { CampaignToolbar, CampaignTable, RegisterCampaign, PreviewCampaign } from './components';

import { PageTitle, SimplePopup } from 'components';

import { IsNoU } from 'common/utils';

// >> redux
import {
  getCampaigns,
  getCampaignInfo,
  addCampaign,
  updateCampaign,
  deleteCampaign,
  findCampaigns,
  removeCampaigns
} from 'redux/actions/campaigns';
// <<


// >> redux
import {
  getAreas,
  getGroups,
} from 'redux/actions/manage';
// <<

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  },
}));

const Campaign = (props) => {
  const classes = useStyles();

  const { 
    campaigns, 
    campaign_total,
    campaignInfo, 
    loading, 
    loadingFind,
    
    areas, 
    groups 
  } = props;

  const [userId, setUserId] = useState(null);
  const [userName, setUserName] = useState(null);
  const [userRole, setUserRole] = useState(null);

  const [openRegisterCampaign, setOpenRegisterCampaign] = useState(false);
  const [modeReserveCampaign, setModeReserveCampaign] = useState(false);
  const [modeRegisterCampaign, setModeRegisterCampaign] = useState(true);

  const [openPreviewCampaign, setOpenPreviewCampaign] = useState(false);
  const [openDeleteAlert, setOpenDeleteAlert] = useState(false);

  const [showRegModal, setShowRegModal] = useState(false);
  const [showPrevModal, setShowPrevModal] = useState(false);

  const [selectedCampaign, setSelectedCampaign] = useState(null);

  const [selectedCampaigns, setSelectedCampaigns] = useState([]);
  const [disableDeleteButton, setDisableDeleteButton] = useState(true);
  const [disableReserveButton, setDisableReserveButton] = useState(true);

  //const [findCampaigns, setFindCampaigns] = useState([]);

  const [find_data, set_find_data] = useState({});

  const handleSearchItem = (name, area, group) => {

    // if (IsNoU(name) || name.length <= 0)
    //   name = 'all';
    // if (IsNoU(area) || area.length <= 0)
    //   area = 'all';
    // if (IsNoU(group) || group.length <= 0)
    //   group = 'all';

    // //console.log(name + agency + client);
    
    // const findItems = campaigns.filter((campaign) => {
    //   // console.log(advertise);
    //   // console.log(advertise.name.indexOf(name));
    //   // console.log(advertise.agency.indexOf(agency));
    //   // console.log(advertise.client.indexOf(client));
    //   return (name === 'all' || campaign.name.indexOf(name) !== -1)
    //     && (area === 'all' || campaign.area.indexOf(area) !== -1)
    //     && (group === 'all' || group.client.indexOf(group) !== -1) ;
    // });

    // //console.log(findItems);

    let campaign_name = '';
    let campaign_area = '';
    let campaign_group = '';
    if (name.length > 0)
      campaign_name = name;
    if (area !== '전체')
      campaign_area = area;
    if (group !== '전체')
      campaign_group = group;

    setPage(0);

    let find_data = {
      name: campaign_name,
      area: campaign_area,
      group: campaign_group,
      page: page,
      rows_per_page: rowsPerPage,
    };
    set_find_data(find_data);

    props.findCampaigns(find_data);

  }

  const handleClickOpenRegisterCampaign = () => {
    setModeReserveCampaign(false);
    setModeRegisterCampaign(true);
    setSelectedCampaign(null);
    setOpenRegisterCampaign(true);
  };

  const handleClickOpenReserveCampaign = () => {
    if (selectedCampaigns.length !== 1){
      return ;
    }

    const id = selectedCampaigns[0];
    const selectedCampaign = campaigns.find(campaign => (campaign.id === id));

    //handleClickEditReservedCampaign(selectedCampaign);

    setShowRegModal(true);
    setModeReserveCampaign(true);
    setModeRegisterCampaign(true);
    props.getCampaignInfo(selectedCampaign.id);
  };

  const handleClickCloseRegisterCampaign = () => {
    setOpenRegisterCampaign(false);
  };

  const handleClickSaveCampaign = (campaign) => {
    if (modeReserveCampaign)
    {
      //console.log('reserve mode ->');
      //console.log(campaign);
      // if (modeRegisterCampaign)
      //   props.addCampaign(campaign);
      // else
        props.updateCampaign(campaign.id, campaign);
    }
    else 
    {
      if (modeRegisterCampaign)
        props.addCampaign(campaign);
      else
        props.updateCampaign(campaign.id, campaign);
    }
    setOpenRegisterCampaign(false);
  }

  const handleClickOpenDeleteAlert = () => {
    if (selectedCampaigns.length === 0){
      return ;
    }
    setOpenDeleteAlert(true);
  };

  const handleClickCloseDeleteAlert = () => {
    setOpenDeleteAlert(false);
  }
  const handleClickDeleteAlertOk = () => {

    //console.log('handleClickDeleteAlertOk -> ' + selectedTemplates.length);
    if (selectedCampaigns.length === 0){
      return ;
    }

    const deletes = selectedCampaigns.map((selected)=>{
      return campaigns.find(campaign => (campaign.id === selected));
    });

    //console.log('handleClickDeleteAlertOk -> ' + type + ',' + deletes);

    props.deleteCampaign(deletes);

    setOpenDeleteAlert(false);
  }

  const handleSetSelectedCampaigns = (checks) => {
    setSelectedCampaigns(checks);
  }

  const handleClickClosePreviewCampaign = () => {
    setOpenPreviewCampaign(false);
  };

  const handleClickEditDeployedCampaign = (campaign) => {
    setShowRegModal(true);
    setModeReserveCampaign(false);
    setModeRegisterCampaign(false);
    props.getCampaignInfo(campaign.id);
    //setOpenRegisterCampaign(true);
  }
  
  const handleClickEditReservedCampaign = (campaign) => {
    setShowRegModal(true);
    setModeReserveCampaign(true);
    setModeRegisterCampaign(false);
    props.getCampaignInfo(campaign.id);
    //setOpenRegisterCampaign(true);
  }

  const handleClickPreviewCampaign = (campaign) => {

    setShowPrevModal(true);
    props.getCampaignInfo(campaign.id);
    //setOpenPreviewCampaign(true);
  }

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  const handlePageChange = (event, page) => {
    setPage(page);
    let find_page_data = {
      name: find_data.name,
      area: find_data.area,
      group: find_data.group,
      page: page,
      rows_per_page: rowsPerPage,
    };
    set_find_data(find_page_data);

    props.findCampaigns(find_page_data);
  };

  const handleRowsPerPageChange = e => {
    let rows_per_page = e.target.value;
    setRowsPerPage(rows_per_page);
    setPage(0);
    let find_page_data = {
      name: find_data.name,
      area: find_data.area,
      group: find_data.group,
      page: 0,
      rows_per_page: rowsPerPage,
    };
    set_find_data(find_page_data);

    props.findCampaigns(find_page_data);
  };

  useEffect(() => {
    //console.log("componentDidMount");
    //console.log(props);
    //console.log('type -> ' + type + ', category -> ' + category);
    props.getAreas();
    props.getGroups();
    
    const jwt = localStorage.getItem('jwt');
    //console.log(''+jwt);

    if (jwt) {
      const decoded = jwtDecode(jwt);

      if (decoded.userid !== null) {
        setUserId(decoded.userid);
      }
      if (decoded.name !== null) {
        setUserName(decoded.name);
      }
      if (decoded.role !== null) {
        setUserRole(decoded.role);
      }
    }
    
    return () => {
      //console.log("componentDidUnmount");
      props.removeCampaigns();
    };
  }, []); // empty-array means don't watch for any updates

  useEffect(() => {
    //console.log("componentDidMount");
    setSelectedCampaign(campaignInfo);

    if (showRegModal) {
      setOpenRegisterCampaign(true);
      setShowRegModal(false);
    }
    else if (showPrevModal) {
      setOpenPreviewCampaign(true);
      setShowPrevModal(false);
    }

  }, [campaignInfo]); // empty-array means don't watch for any updates

  useEffect(() => {
    //console.log('componentDidUpdate & selectedTemplates changed');
 
    setDisableDeleteButton(selectedCampaigns.length < 1);
    if (selectedCampaigns.length === 1) {
      const id = selectedCampaigns[0];
      const selectedCampaign = campaigns.find(campaign => (campaign.id === id));
      setDisableReserveButton(!IsNoU(selectedCampaign.reserved_at));
    }
    else {
      setDisableReserveButton(true);
    }

  }, [selectedCampaigns]);

  // useEffect(() => {
  //   //console.log("componentDidUpdate & campaigns changed");
  //   if (!IsNoU(campaigns) && campaigns.length > 0) {
  //     setFindCampaigns(campaigns);
  //   }
  //   else {
  //     setFindCampaigns([]);
  //   }
  // }, [campaigns]); // empty-array means don't watch for any updates

  if (loading && !openRegisterCampaign) {
    return <WaveLoading />;
  }

  return (
    <div className={classes.root}>

      <PageTitle 
        pageTitle={'캠패인 목록'}
      />

      <CampaignToolbar 
        onClickSearch={handleSearchItem}
        areas={[{id:-1, name: '전체'}, ...areas]}
        groups={[{id:-1, name: '전체'}, ...groups]}
      />

      <div className={classes.content}>
        <CampaignTable 
          userRole={userRole}
          onClickOpenRegisterDialog={handleClickOpenRegisterCampaign}
          onClickOpenReserveDialog={handleClickOpenReserveCampaign}
          onClickOpenDeleteDialog={handleClickOpenDeleteAlert}
          disableDeleteButton={disableDeleteButton}
          disableReserveButton={disableReserveButton}

          campaigns={campaigns}
          onSetSelectedCampaigns={handleSetSelectedCampaigns}
          onClickEditDeployedCampaign={handleClickEditDeployedCampaign}
          onClickEditReservedCampaign={handleClickEditReservedCampaign}
          onClickPreviewCampaign={handleClickPreviewCampaign} 

          openProgress={loadingFind}
          page={page}
          rowsPerPage={rowsPerPage}
          item_total={campaign_total}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        />

      </div>

      <RegisterCampaign 
        openDialog = {openRegisterCampaign}
        modeReserveDialog = {modeReserveCampaign}
        modeRegisterDialog = {modeRegisterCampaign}
        onClickCloseDialog = {handleClickCloseRegisterCampaign}
        onClickSaveDialog = {handleClickSaveCampaign}
        editCampaign = {selectedCampaign}

        areas={areas}
        groups={groups}
        />

      <PreviewCampaign 
        openDialog={openPreviewCampaign}
        onClickCloseDialog={handleClickClosePreviewCampaign}
        campaign={selectedCampaign}
      />

      <SimplePopup
        title={`캠패인을 삭제하시겠습니까?`} 
        openPopup={openDeleteAlert} 
        onClickClose={handleClickCloseDeleteAlert} 
        onClickOk={handleClickDeleteAlertOk}
        />

    </div>
  );
};


Campaign.propTypes = {
  loading: PropTypes.bool,
  campaigns: PropTypes.arrayOf(PropTypes.object),
  campaignInfo: PropTypes.object,

  loadingArea: PropTypes.bool,
  areas: PropTypes.arrayOf(PropTypes.object),
  groups: PropTypes.arrayOf(PropTypes.object),
};

Campaign.defaultProps = {
  loading: false,
  campaigns: [],
  campaignInfo: {},

  loadingArea: false,
  areas: [],
  groups: [],
};

const mapStateToProps = state => ({
  loading: state.campaigns.loading,
  loadingFind: state.campaigns.find_loading,
  campaigns: state.campaigns.campaignList,
  campaign_total: state.campaigns.campaign_total,
  campaignInfo: state.campaigns.campaignInfo,

  loadingArea: state.manage.loading,
  areas: state.manage.reged_areaList,
  groups: state.manage.groupList,
});

const mapDispatchToProps = dispatch => ({
  getCampaigns: () => {getCampaigns(dispatch)},
  getCampaignInfo: (id) => {getCampaignInfo(id, dispatch)},
  addCampaign: (campaign) => {addCampaign(campaign, dispatch)},
  updateCampaign: (id, campaign) => {updateCampaign(id, campaign, dispatch)},
  deleteCampaign: (deletes) => {deleteCampaign(deletes, dispatch)},

  findCampaigns: (find) => {findCampaigns(find, dispatch)},
  removeCampaigns: () => {removeCampaigns(dispatch)},

  getAreas: () => {getAreas(dispatch)},
  getGroups: () => {getGroups(dispatch)},  
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Campaign);

//export default Campaign;
